var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ex-card",class:{'card-transparent' : _vm.transparent}},[_c('div',{staticClass:"ex-card-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"ex-card-body",class:{'pa-0' : _vm.disableOffsets}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47911538","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Card.vue
// module id = null
// module chunks = 